/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './name.module.scss';
import { useThemeMode } from '../../../../../states/contexts/theme';

interface Props {
    recipient_name: string
}
const Name: React.FC<Props> = ({ recipient_name }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <section className={styles.name} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                theme === 'dark' ? <img src="/person-white.svg" alt="" width={21} height={21} /> :
                    <img src="/person-grey.webp" alt="" width={21} height={21} />
            }
            <h5>Recipient’s Name: {recipient_name}</h5>
        </section>
    )
}
export default Name;